import { ClearableTextField } from '@app/components/form/ClearableTextField';
import { ComponentProps } from 'react';
import { defineMessage, useIntl } from 'react-intl';

export const orderFieldMessage = defineMessage({
  id: 'audit.props.order',
  defaultMessage: 'Orden',
});

type OrderFieldProps = Omit<ComponentProps<typeof ClearableTextField>, 'name' | 'label'> & {
  name?: string;
  label?: string;
};

/**
 * Shared Formik text field for filtering by order.
 */
export function OrderField({
  name = 'order',
  submitOnClear = true,
  label,
  ...props
}: OrderFieldProps) {
  const { $t } = useIntl();

  return (
    <ClearableTextField
      name={name}
      submitOnClear={submitOnClear}
      label={label ?? $t(orderFieldMessage)}
      {...props}
    />
  );
}
